// Frist-Ampel eines Auftrags aus `nextDeadlineAt`. Der Server liefert keine Ampel; Schwellen hier:
// überfällig = rot, innerhalb von 3 Tagen = gelb, sonst grün, ohne Frist = grau.
export type Ampel = 'red' | 'amber' | 'green' | 'none'
export const AMPELN: readonly Ampel[] = ['red', 'amber', 'green', 'none']

export const AMPEL_AMBER_WITHIN_MS = 3 * 24 * 60 * 60 * 1000

export function ampelOf(nextDeadlineAt: string | null | undefined, now: Date = new Date()): Ampel {
  if (!nextDeadlineAt) return 'none'
  const due = Date.parse(nextDeadlineAt)
  if (Number.isNaN(due)) return 'none'
  const diff = due - now.getTime()
  if (diff < 0) return 'red'
  return diff <= AMPEL_AMBER_WITHIN_MS ? 'amber' : 'green'
}

/** Farben für Karte (Hex, ausreichender Kontrast zum Kartenhintergrund) und Tabellenpunkt. */
export const AMPEL_COLOR: Record<Ampel, string> = {
  red: '#c0262d',
  amber: '#e69500',
  green: '#2e7d32',
  none: '#6b7280',
}
